import { Text } from '@avanta/shared/components/Text';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { CircleAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { CREATE_EMPLOYEE_STATUS } from 'constants/employees';
import { type CreateEmployeesResult } from 'types/employees';
import { getImportIssueLines } from './util';

type ImportErrorStateProps = {
  results: CreateEmployeesResult[];
};

export const ImportErrorState = ({ results }: ImportErrorStateProps): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.INSURANCE);
  const errorResults = results.filter(result => result.status === CREATE_EMPLOYEE_STATUS.ERROR);
  const existingResults = results.filter(
    result => result.status === CREATE_EMPLOYEE_STATUS.ALREADY_EXISTS
  );
  const failedLines = getImportIssueLines(results).join(' · ');

  return (
    <div className="flex flex-col gap-6 w-full">
      <div
        role="alert"
        className="flex items-center gap-4 rounded-xl border border-red-300 bg-red-100 px-4 py-4"
      >
        <CircleAlert className="size-8 shrink-0 text-red-400" strokeWidth={1.5} />
        <div className="flex flex-col gap-1">
          <Text tag="p" variant="heading-lg-medium" className="text-denim-800">
            {t('ImportPatientsDialog.error.title')}
          </Text>
          {errorResults.length > 0 && (
            <Text variant="text-sm-medium" className="text-red-400">
              {t('ImportPatientsDialog.error.invalidRecords', {
                count: errorResults.length,
              })}
            </Text>
          )}
          {existingResults.length > 0 && (
            <Text variant="text-sm-medium" className="text-red-400">
              {t('ImportPatientsDialog.error.existingRecords', {
                count: existingResults.length,
              })}
            </Text>
          )}
        </div>
      </div>
      <div>
        <Text variant="text-sm-regular" className="text-denim-500">
          {t('ImportPatientsDialog.error.description')}
        </Text>
        <Text variant="text-sm-regular" className="mt-4 text-denim-500">
          {t('ImportPatientsDialog.error.lines', {
            lines: failedLines,
          })}
        </Text>
      </div>
    </div>
  );
};
